import pizzaImg from "./images/Pizza.jpg";
import pitaBreadImg from "./images/Pita-bread.jpg";
import samoonBreadImg from "./images/samoon-bread.jpg";
import burgerImg from "./images/Burger-Bun.jpg";
export const data = [
  {
    id: 0,
    name: "بيتزا",
    img: pizzaImg,
    recipe: [
      " نضع الخميرة في الماء الدافئ مع ملعقة كبيرة من السكر، ونتركها لمدّة حتى تظهر عليها فقاعات هوائية لنتأكد من فاعلية الخميرة.",
      "نضع الدقيق فى إناء واسع، ونشكّل في منتصفه حفرة، ونضع خليط الخميرة في المنتصف.",
      "نضيف الماء والملح وزيت الزيتون على العجينة ونبدأ بالعجن",
      "يجب الاستمرار فى العجن حتى تتماسك العجينة.",
      "ندهن الوعاء بالزيت، ونضع العجينة فيه.",
      "نُغطّي الوعاء بقطعة قماش نظيفة، ونتركه في مكانٍ دافىء ليتخمّر، أي حتى يتضاعف حجمة.",
      "نضع على الطاولة القليل من الطحين، ثمّ نفرد العجين للحجم الذي نرغب به.",
      "نضع مكونات البيتزا فوق العجينة ومن ثم نخبزها لمدة 15-20 دقيقة في الفرن",
    ],
  },
  {
    id: 1,
    name: "خبز عربي",
    img: pitaBreadImg,
    recipe: [
      "نضع الخميرة في الماء الدافئ مع ملعقة كبيرة من السكر، ونتركها لمدّة حتى تظهر عليها فقاعات هوائية لنتأكد من فاعلية الخميرة.",
      "نضع الدقيق فى إناء واسع، ونشكّل في منتصفه حفرة، ونضع خليط الخميرة في المنتصف.",
      "نضيف الماء والملح وزيت الزيتون والحليب على العجينة ونبدأ بالعجن",
      "يجب الاستمرار فى العجن حتى تتماسك العجينة.",
      "وضع العجينة في طبق مدهون بالزيت، ودهن سطح العجينة بقليل من الزيت، وتغطيتها بقطعة من النايلون، ثمّ وضعها في مكان دافئ حتّى يتضاعف حجمها.",
      " وضع العجينة على سطح مرشوش بالدقيق، ثمّ فردها باستخدام النشابة.",
      " تقطيع العجينة باستخدام قطاعة البسكويت، ثمّ وضعها في صينية، وتغطيتها بالنايلون لمدّة ثلاثين دقيقة حتّى يتضاعف حجمها.",
      " إحضار صواني قصيرة الحافة، ثمّ تسخين الفرن على درجة حرارة 200 درجة مئوية، ووضع العجينة في الصواني مع ترك مسافة بين كلّ قطعة والأخرى.",
      " خبز العجينة في الفرن لمدّة 10-12 دقيقة حتّى تُصبح ذهبية اللون. تقديم الخبز العربي مع المقبلات والأجبان.",
    ],
  },
  {
    id: 2,
    name: "خبز الصمون",
    img: samoonBreadImg,
    recipe: [
      "ضعي السكر والخميرة في كوب من الماء الدافىء، وانتظري حتى تنتفخ الخميرة. ",
      "اخلطي الدقيق مع المِلح. أضيفي الزيت، وافركي الدقيق بالزيت. أضيفي الخميرة والسكر إلى الدقيق، وابدئي بالعجن. قد تحتاجين إلى القليل من الماء؛ لذلك أضيفيه واستمري في العجن لمدةٍ لا تَقلُ عن ست دقائق.",
      "يجب أنْ تتشكّل لديك عجينة متماسكة لا تلتصق باليد.",
      "اتركي العجينةَ لمدةِ رُبع ساعة، وستلاحظين أنّها قد انتفخت؛ وهذا يعني أنّها أصبحت جاهزةً للخبز.",
      " اشعلي الفرن، وابدئي بتقطيع العجينة وتشكيلها؛ بحيث تَكون كلّ قطعةٍ مَلفوفةٍ على شكلِ أسطوانة.",
      " أحضري صينية الفرن، وضعي قطعَ الصمون فيها، واخبزي الصمون لمدةٍ ما بين 20 - 25 دقيقة.",
    ],
  },
  {
    id: 3,
    name: "خبز البرجر",
    img: burgerImg,
    recipe: [
      "حمّي الفرن على حرارة 200 درجة مئوية وادهني صينية فين غير لاصقة بالقليل من الزيت. ",
      "في وعاء كبير أخلطي الماء مع الخميرة، السكر والزيت.",
      "أضيفي البيضة، الدقيق والملح. أخلطي المكوّنات بواسطة ملعقة خشبية ثمّ إدعكيها بواسطة يديك.",
      "غطّي العجينة لـ5 دقائق ثمّ قطّعيها إلى 12 كرة صغيرة وصفّيها على الصينية.",
      "إدهني وجه العجين بالبيض ثمّ أنثري السمسم.",
      "أدخلي الصينية إلى الفرن لـ10 دقائق حتى ينضج الخبز ويحمر.",
    ],
  },
];
